import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEclipse = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 10 10",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5,
		r: 5
	})
});
export default SvgEclipse;
